import { capabilities } from '@/mocks/red-packet';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function Capabilities() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="核心能力"
          title="让每一笔红包都更有价值"
          subtitle="围绕发放、触达、核销与数据四个环节，构建完整的数字红包运营能力。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {capabilities.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 80}>
              <div className="group relative h-full p-6 rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1 hover:border-secondary-300 hover:shadow-[0_12px_32px_rgba(0,0,0,0.06)]">
                <span className="absolute top-6 right-6 text-xs font-semibold text-foreground-300 tracking-widest">
                  0{idx + 1}
                </span>

                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-background-50 border border-background-200 text-secondary-600 transition-colors group-hover:bg-secondary-100 group-hover:text-secondary-700">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="mt-5 font-heading font-bold text-xl text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>

                <div className="mt-4 flex flex-wrap gap-2">
                  {item.points.map((point) => (
                    <span
                      key={point}
                      className="px-2.5 py-1 rounded-full text-xs text-secondary-800 bg-secondary-100 whitespace-nowrap"
                    >
                      {point}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}